import React, { FC, useEffect, useState } from "react";
import { IObject } from "toolkit/steps/stepSeven/stepSeven.types";
import { MyTextarea } from "pages/StepPages/StepTwo/MyTextarea/MyTextarea";
import { MyInput } from "pages/StepPages/StepTwo/MyInput/MyInput";
import { MySelect } from "pages/StepPages/StepTwo/MySelect/MySelect";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useParams } from "react-router-dom";
import { ReactComponent as FileIcon } from "images/file.svg";
import { useAppDispatch } from "toolkit/hooks";
import { dowloadDocument, editInfo, BGupdateDocument } from "toolkit/steps/stepSeven/stepSeven.thunks";
import styles from "./ViewingInfo.module.sass";
import {objectsKiiAPI} from "libs/apiClient/ObjectsKii";

interface ViewingInfoProps {
	close: () => void;
	object: IObject;
}

export const ViewingInfo: FC<ViewingInfoProps> = ({ close, object }) => {
	const [registrationNumber, setRegistrationNumber] = useState<string>("");
	const [submitError, setSubmitError] = useState<boolean>(false);
	const { organizationId } = useParams();
	const dispatch = useAppDispatch();
	const [newDocument, setNewDocument] = useState<any>(null);
	const [selectedCategory, setSelectedCategory] = useState<{
		id: number | null;
		name: string;
	}>({
		id: null,
		name: "",
	});

	const categoriesList = [
		{ id: 99, name: "Не присвоена" },
		{ id: 1, name: "1" },
		{ id: 2, name: "2" },
		{ id: 3, name: "3" },
	];

	const categories = {
		99: "Не присвоена",
		1: "1",
		2: "2",
		3: "3",
	};

	// reading logging
	// useEffect(() => {
	//     $api.get(`/objects_kii/${organizationId}/exported/${object.id}/touch?action=READ`);
	// }, [])

	useEffect(() => {
		if (object.fstekId) setRegistrationNumber(String(object.fstekId));

		if (object.fstekCategory)
			setSelectedCategory({
				id: object.fstekCategory,
				name: categories[object.fstekCategory as keyof typeof categories],
			});
		//eslint-disable-next-line
	}, []);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		if (!organizationId) return;
		e.preventDefault();
		if (!registrationNumber.trim()) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			if (newDocument?.name) {
				dispatch(
					BGupdateDocument({
						organizationId: +organizationId,
						file: newDocument,
						attachmentList: [object.id],
					}),
				);
			}
			if (registrationNumber !== String(object.fstekId) || selectedCategory.id !== object.fstekCategory) {
				dispatch(
					editInfo({
						organizationId: +organizationId,
						objectId: object.id,
						registrationNumber: registrationNumber,
						selectedCategory: selectedCategory.id,
						handler: !Boolean(newDocument?.name),
					}),
				);
			}
			close();
		}
	};

	const downloadingHandler = () => {
		if (!organizationId || newDocument) return;
		objectsKiiAPI.exportedTouchDetail(+organizationId!,object.id,{action:"DOWNLOAD"})
		dispatch(
			dowloadDocument({
				organizationId: +organizationId,
				name: object.fstekLetter!.name,
				documentKey: object.fstekLetter!.key,
			}),
		);
	};

	const updatingHandler = (files: FileList | null) => {
		if (files?.length) setNewDocument(files![0]);
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Просмотр итоговой информации по ОКИИ</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<div className={styles.item}>
						<MyTextarea
							className={styles.area}
							name="Наименование объекта"
							placeholder=""
							value={object.name}
							set={() => {}}
							resize="none"
							readOnly={true}
						/>
					</div>
					<MyInput
						className={styles.item}
						name="Код объекта"
						placeholder=""
						value={object.code}
						set={() => {}}
						readOnly={true}
					/>
					<MyInput
						className={styles.item}
						required={true}
						condition={submitError && !registrationNumber.trim()}
						name="Реестровый номер"
						placeholder={"1517745555"}
						value={registrationNumber}
						set={(e) => {
							setRegistrationNumber(e.target.value);
						}}
					/>
					<div className={styles.item}>
						{/* <MySelect className={styles.item} list={categoriesList} value={"test value"} set={(selected) => setSelectedCategory(selected)} name="Изменить категорию значимости" placeholder="Выберите категорию" required={true} error={submitError} width="full" scroll={false} search={false} /> */}
						<MySelect
							className={styles.item}
							list={categoriesList}
							value={selectedCategory.name}
							set={(selected) => setSelectedCategory(selected)}
							name="Изменить категорию значимости"
							placeholder="Выберите категорию"
							required={true}
							error={submitError}
							width="full"
							scroll={false}
							search={false}
						/>
					</div>
					<div className={styles.item}>
						<div className={styles["document-wrp"]}>
							<div onClick={downloadingHandler} className={styles.document}>
								<div>
									<FileIcon className={styles["document-icon"]} />
								</div>
								<span className={styles["document-name"]}>{newDocument?.name || object.fstekLetter?.name}</span>
							</div>
							<label className={styles["document-change"]} htmlFor={`changeDoc-${object.id}`}>
								Изменить
							</label>
							<input
								onChange={(e) => updatingHandler(e.target.files)}
								type="file"
								id={`changeDoc-${object.id}`}
								className="none"
								accept=".docx, .pdf, .rtf"
							/>
						</div>
					</div>
					<div className={styles.item}>
						<MyTextarea
							className={styles.area}
							name="Заполнил итоговую информацию"
							placeholder=""
							value={object.editor?.name || "—"}
							set={() => {}}
							resize="none"
							readOnly={true}
						/>
					</div>
				</div>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отменить
					</Button>
					<Button type="submit" className={styles.button}>
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
